import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IListRetailerAddressesRequest) {
    (function(AddressFilter) {
        AddressFilter["ADDRESS_FILTER_UNKNOWN"] = "ADDRESS_FILTER_UNKNOWN";
        /**
     * Not associated with a store or payment method.
     */ AddressFilter["UNASSIGNED_ADDRESSES"] = "UNASSIGNED_ADDRESSES";
    })(IListRetailerAddressesRequest.AddressFilter || (IListRetailerAddressesRequest.AddressFilter = {}));
    IListRetailerAddressesRequest.build = function(partial) {
        return _object_spread({
            address_filters: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IListRetailerAddressesRequest || (IListRetailerAddressesRequest = {}));
export var IListRetailerAddressesRequest;
